import { Injectable } from "@angular/core";
import { MessageType, SessionSummary, AbstractTranslatableSnackBarService } from "@obg/ngx.core";
import { TranslationGroup, TranslationService } from "@obg/ngx.core.content";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class NotificationService {
	constructor(
		private snackBarService: AbstractTranslatableSnackBarService,
		private translationService: TranslationService
	) {}

	openLogoutSnackbar$(sessionSummary?: SessionSummary, sessionSummaryEnabled?: boolean): Observable<object> {
		const translatedProducts = (sessionSummary?.productsUsed?.length ? sessionSummary.productsUsed : ["none"]).map(
			(product) => this.translationService.getByKey(`user-summary.session-summary-product-${product}`)
		);
		return this.snackBarService.openSnackBar$(
			{
				message:
					sessionSummary && sessionSummaryEnabled
						? "general.logout-success-message-with-session-summary"
						: "general.logout-success-message",
				action: "general.close",
				duration: 4000,
				keepOpen: sessionSummaryEnabled,
				type: MessageType.Success,
			},
			[TranslationGroup.General],
			{ ...sessionSummary, productsUsed: translatedProducts }
		);
	}
}
